import Image from "../CustomImage";
import youtube_icon_red from '~/public/images/youtube_icon_red.inline.svg';

export const RenderCustomThumbs = (mediaList, styles ) =>{

    let thumbList = []
        thumbList = mediaList
            ?.slice()
            ?.sort((a, b) => a.position - b.position)
            ?.sort((a, b) => a.__typename.localeCompare(b.__typename))
            ?.map((image, index) =>
                image?.video_content == null ? (
                    <Image
                        width={64}
                        height={64}
                        className={styles.pdpBanner}
                        key={index}
                        loading={index == 0 ? 'eager' : 'lazy'}
                        src={image.url}
                        alt={image.label} />
                ) : (
                    <div key={index} className={styles.youtube_icon_thumbs}>
                        <div className={styles.youtube_icon}>
                            <img loading='lazy' src={youtube_icon_red} alt="youtube_icon_red" width="16" height="11" />
                        </div >
                        <Image
                            width={64}
                            height={64}
                            className={styles.pdpBanner}
                            loading={index == 0 ? 'eager' : 'lazy'}
                            src={image.url}
                            alt={image.label} />
                    </div>
                )
            );

        return thumbList;
}